"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const computeTransition_1 = __importStar(require("../../../ControlStyleFormaters/shared/computeTransition"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const TransitionRenderer = ({ transition, children, style, }) => {
    const { Render, dimentions, Animated, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const onAnimationStyle = (0, react_1.useCallback)(() => {
        const duration = (0, computeTransition_1.computeTransitionSpeed)(transition === null || transition === void 0 ? void 0 : transition.speed);
        const animationValue = new Animated.Value(0);
        Animated.timing(animationValue, {
            toValue: 1,
            duration,
            useNativeDriver: true,
        }).start();
        const animatedStyle = (0, computeTransition_1.default)({
            animationValue,
            transition: transition === null || transition === void 0 ? void 0 : transition.type,
            dimensions: dimentions.window,
        });
        return animatedStyle;
    }, [Animated, dimentions.window, transition]);
    const animatedStyle = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, style), onAnimationStyle())), [style, onAnimationStyle]);
    return (react_1.default.createElement(Render.AnimatedView, { style: animatedStyle }, children));
};
exports.default = TransitionRenderer;
